import React from "react";
import { Snackbar, Alert } from "@mui/material";
import PropTypes from "prop-types";

const SnackbarAlert = ({ isOpen, handleClose, message, type }) => {
	return (
		<Snackbar
			anchorOrigin={{
				vertical: "top",
				horizontal: "center"
			}}
			open={isOpen}
			onClose={handleClose}
			autoHideDuration={2000}
			message={message}
		>
			<Alert onClose={handleClose} severity={type} sx={{ width: "100%" }}>
				{message}
			</Alert>
		</Snackbar>);
};

SnackbarAlert.propTypes = {
	isOpen: PropTypes.bool,
	handleClose: PropTypes.func,
	message: PropTypes.string,
	type: PropTypes.string
};

SnackbarAlert.defaultProps = {
	isOpen: false,
	handleClose: null,
	message: "",
	type: ""
};

export default SnackbarAlert;
